import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, Spin } from 'antd';
import validator from 'validator';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../../admin/i18n/adminI18n';

@inject('outOfStockRecipientStore')
@observer
class UpdateOutOfStockRecipientModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    createClicked = () => this.props.outOfStockRecipientStore.createOutOfStockRecipient();

    updateClicked = () => this.props.outOfStockRecipientStore.updateOutOfStockRecipient();

    cancelClicked = () => this.props.outOfStockRecipientStore.setShowUpdateOutOfStockRecipientModal(false);

    render() {
        const { t } = this.props;
        const {
            outOfStockRecipientId,
            email,
            updateLoading
        } = this.props.outOfStockRecipientStore;

        const isValid = email !== '' && validator.isEmail(email);

        return (
            <Spin spinning={updateLoading}>
                <Form layout='vertical'>
                    <Form.Item label={t('Email')}>
                        <Input placeholder={t('Set email')} value={email} onChange={(e) => this.props.outOfStockRecipientStore.setEmail(e.target.value)} />
                        {
                            validator.isEmail(email) || email === '' ? null : <span style={{ paddingTop: 2, color: 'red', display: 'block' }}>{t('Invalid Email')}</span>
                        }
                    </Form.Item>

                    <Form.Item>
                        {
                            outOfStockRecipientId === 0
                                ?
                                (
                                    isValid
                                        ?
                                        <Button onClick={this.createClicked} style={{ marginRight: 10 }} type='primary'>{t('Create')}</Button>
                                        :
                                        <Button disabled style={{ marginRight: 10 }} type='primary'>{t('Create')}</Button>
                                )
                                :
                                (
                                    isValid
                                        ?
                                        <Button onClick={this.updateClicked} style={{ marginRight: 10 }} type='primary'>{t('Update')}</Button>
                                        :
                                        <Button disabled style={{ marginRight: 10 }} type='primary'>{t('Update')}</Button>
                                )
                        }

                        <Button onClick={this.cancelClicked}>{t('Cancel')}</Button>
                    </Form.Item>
                </Form>
            </Spin>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(UpdateOutOfStockRecipientModal);